export var toastIconMap = {
    info: 'info',
    success: 'circleCheck',
    error: 'circleX',
    warning: 'circleTriangle',
};
export var toastIconFill = {
    info: 'blue2',
    success: 'darkGreen',
    error: 'red1',
    warning: 'yellow1',
};
export var toastTitleMap = {
    info: 'Info',
    success: 'Success',
    error: 'Error',
    warning: 'Warning',
};
